module.exports = __webpack_public_path__ + "static/media/ic_arrow_down.84afbfbb.svg";